import { Box, Typography } from '@mui/material';
import { ReactNode } from 'react';

interface BlueprintStepSectionProps {
  title: ReactNode;
  children: ReactNode;
  /** Bottom margin in pixels */
  bottomSpacing?: number;
  /** Title bottom margin in pixels */
  titleSpacing?: number;
}

export const BlueprintStepSection = ({
  title,
  children,
  bottomSpacing = 24,
  titleSpacing = 20,
}: BlueprintStepSectionProps) => {
  return (
    <Box sx={{ mb: `${bottomSpacing}px` }}>
      {typeof title === 'string' ? (
        <Typography variant="subtitle2" sx={{ mb: `${titleSpacing}px`, lineHeight: 'normal' }}>
          {title}
        </Typography>
      ) : (
        <Box sx={{ mb: `${titleSpacing}px` }}>{title}</Box>
      )}
      {children}
    </Box>
  );
};
